var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Arrays } from '@pacem/pacem-foundation';
import { Components, PropertyConverters, Utils, P, PCSS, CustomElement, Watch, Defaults, ViewChild } from '@pacem/pacem-core';
import { PacemBaseInputElement } from './input';
//namespace Pacem.Components.Scaffolding {
let PacemCharsInputElement = class PacemCharsInputElement extends PacemBaseInputElement {
    constructor() {
        super();
        this.charCount = 6;
        this.inputTransform = 'none';
        this._itemCreateHandler = (e) => {
            const { dom, index } = e.detail;
            const inputField = dom.find(i => i instanceof HTMLInputElement);
            this.#inputs[index] = inputField;
            this.registerInputFields(inputField);
        };
        this.#inputs = [];
    }
    redactViewValue(value = this.value) {
        this.viewValue = this.getViewValue(value);
    }
    getValue(_) {
        const val = this.#inputs.reduce((acc, input) => acc + (Utils.isNullOrEmpty(input.value) ? ' ' : input.value), '');
        switch (this.inputTransform) {
            case 'lowercase':
                return val.toLowerCase();
            case 'uppercase':
                return val.toUpperCase();
            default:
                return val;
        }
    }
    getViewValue(value) {
        const size = this.charCount;
        return this.inputTransform == 'password' ? Arrays.range(size).map(i => '*').join('') : value;
    }
    convertValueAttributeToProperty(attr) {
        return attr;
    }
    toggleReadonlyView(readonly = this.readonly) {
        this._span.hidden = !readonly;
        this._chars.hidden = readonly;
    }
    /** Override base behavior. */
    focus() {
        // check if one of the fields has already focus, if so, do not steal it.
        for (let inputField of this.inputFields ?? []) {
            if (inputField === document.activeElement) {
                if (this.autofocus) {
                    inputField.select();
                }
                return;
            }
        }
        super.focus();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (first) {
            return;
        }
        switch (name) {
            case 'charCount':
                this._databind();
                this.redactViewValue();
                break;
            case 'inputTransform':
                this.registerInputFields();
                this.value = this.getValue(this.value);
                break;
        }
    }
    /**
     * Override to apply input transform to all input fields.
     * @param fields
     */
    registerInputFields(fields = this.inputFields) {
        super.registerInputFields(fields);
        if (!Utils.isNull(fields) && !Utils.isArray(fields)) {
            fields = [fields];
        }
        const inputs = this.#inputs;
        for (let inputField of fields ?? []) {
            const ndx = inputs.indexOf(inputField);
            Utils.toggleClass(inputField, 'last-char', ndx === (this.charCount - 1));
            Utils.toggleClass(inputField, 'first-char', ndx === 0);
            if (Utils.isNullOrEmpty(inputField.id)) {
                inputField.setAttribute('id', 'code_' + ndx + '_' + Utils.uniqueCode());
            }
            inputField.value = this.value?.charAt(ndx) || '';
            if (this.inputTransform === 'password') {
                inputField.setAttribute('type', 'password');
            }
            else {
                inputField.setAttribute('type', 'text');
            }
        }
    }
    acceptValue(val) {
        // shadow super method
        // update ui
        const inputs = this.#inputs;
        if (typeof val === 'string') {
            let counter = 0;
            const limit = Math.min(val.length, inputs.length);
            for (let j = 0; j < limit; j++) {
                inputs[j].value = val.charAt(j);
                counter++;
            }
            for (let j = counter; j < inputs.length; j++) {
                inputs[j].value = '';
            }
        }
    }
    onChange(evt) {
        return super.onChange(evt).then(v => {
            const inputs = this.#inputs, index = inputs.indexOf(evt.target);
            if (index >= 0 && index < (inputs.length - 1)) {
                const input = inputs[index];
                if (Utils.isNullOrEmpty(input.value?.trim())) {
                    input.value = '';
                }
                else {
                    const next = index + 1;
                    inputs[next].focus();
                }
            }
            return v;
        });
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        if (Utils.isNull(this.autoselect)) {
            // defaults autoselect to true
            this.autoselect = true;
        }
        this._chars.addEventListener(Components.RepeaterItemCreateEventName, this._itemCreateHandler, false);
        this._databind();
    }
    disconnectedCallback() {
        const repeater = this._chars;
        if (!Utils.isNull(repeater)) {
            repeater.removeEventListener(Components.RepeaterItemCreateEventName, this._itemCreateHandler);
        }
        super.disconnectedCallback();
    }
    _databind() {
        const size = this.charCount, inputs = this.#inputs;
        if (inputs.length > size) {
            super.unregisterInputFields(inputs.splice(size));
        }
        this._chars.datasource = Arrays.range(size);
    }
    #inputs;
    get inputFields() {
        return this.#inputs;
    }
};
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.Number })
], PacemCharsInputElement.prototype, "charCount", void 0);
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.String })
], PacemCharsInputElement.prototype, "inputTransform", void 0);
__decorate([
    ViewChild(P + '-repeater')
], PacemCharsInputElement.prototype, "_chars", void 0);
__decorate([
    ViewChild('span.' + PCSS + '-readonly')
], PacemCharsInputElement.prototype, "_span", void 0);
PacemCharsInputElement = __decorate([
    CustomElement({
        tagName: P + '-input-chars',
        template: `<${P}-repeater class="display-flex flex-nowrap">
        <template><input type="text" class="${PCSS}-input flex-auto" maxlength="1" /></template>
        </${P}-repeater><span class="${PCSS}-readonly"><${P}-text text="{{ :host.viewValue }}"></${P}-text></span>`,
        shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemCharsInputElement);
export { PacemCharsInputElement };
